export interface ShortObjectDto {
    id: number;
    guid: string;
    name: string;
}

export interface GetObjectsResponse {
    objects: ShortObjectDto[];
}

export enum ItemStatus {
    Recieved = 0,
    Pending = 1,
    NA = 2
}

export interface VitroDirectoryItemDto {
    id: string;
    name: string;
    documentStatus: string;
    version: string;
    modified: string;
    initiator: string;
    initiatorOrganization: string;
    fileId: string;
    vitroUrl: string;
    sheetCetCipher: string;
    designStage: string;
    projectLookup: string;
    note: string;
    stage: string;
    statusSubcategory: string;
    childCount: number;
    parentId: string;
    status: ItemStatus
}

export interface VitroInfoResult {
    recieved: number;
    pending: number;
    na: number;
    data: Record<string, VitroDirectoryItemDto[]>;
}